import { BlockControls, InspectorControls } from "@wordpress/block-editor";
import {
  ToolbarButton,
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToolsPanelItem as ToolsPanelItem,
  __experimentalUnitControl as UnitControl,
  __experimentalUseCustomUnits as useCustomUnits,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { useMemo } from "react";
import { useToolsPanelDropdownMenuProps } from "./hooks";

export default function Icon({
  attributes,
  setAttributes,
  setIsIconsModalOpen,
  blockEditingMode,
}) {
  const { iconName, iconType } = attributes;

  const isContentOnlyMode = blockEditingMode === "contentOnly";

  const dimensionsUnitsOptions = useCustomUnits({
    availableUnits: ["px"],
  });

  const dropdownMenuProps = useToolsPanelDropdownMenuProps();

  const iconHtml = useMemo(() => {
    if (iconName === "") {
      return "";
    }

    const iconHtml = (
      <div className={`wp-block-brandy-icon`}>
        <i
          className={`ph${
            iconType !== "regular" ? "-" + iconType : ""
          } ph-${iconName}`}
        ></i>
      </div>
    );

    return iconHtml;
  }, [iconType, iconName]);

  const iconReplaceFlow = (
    <BlockControls group={isContentOnlyMode ? "inline" : "other"}>
      <ToolbarButton
        onClick={() => {
          setIsIconsModalOpen(true);
        }}
      >
        {iconName ? __("Replace") : __("Add icon")}
      </ToolbarButton>
    </BlockControls>
  );

  return (
    <>
      {iconReplaceFlow}
      {iconName !== "" && iconHtml}
    </>
  );
}
